import ApartmentOutlined from '@mui/icons-material/ApartmentOutlined';
import { IAbsenteeismRateItem } from '../../../interfaces/IAbsenteeismRate';
import { AbsenteeismRateCard } from './AbsenteeismRateCard';

export const RankSubsidiaryWithMoreMedicalCertificate = ({ data }: { data: IAbsenteeismRateItem[] }) => (
  <AbsenteeismRateCard
    icon={<ApartmentOutlined />}
    title="Taxa de absenteísmo por filial"
    subtitle="Colaboradores com atestado sobre o total da filial"
    data={data}
  />
);
